export const palette = {
  ink: {
    normal: "#333333",
  },
  red: {
    dark: "#de0039",
  },
  gray: {
    light: "#F0F0F0",
  },
};

export const fontFamily = {
  gothic: '-apple-system, BlinkMacSystemFont, "Yu Gothic Medium", "游ゴシック Medium", "Yu Gothic", YuGothic, Verdana, Meiryo, sans-serif;',
  serif: '"游明朝", "Yu Mincho", YuMincho, "Hiragino Mincho ProN", "ＭＳ Ｐ明朝", "MS PMincho", "ＭＳ 明朝", "MS Mincho", serif;',
  serif_ie11: '"ヒラギノ明朝 ProN W3", "Hiragino Mincho ProN", "ＭＳ Ｐ明朝", "MS PMincho", "ＭＳ 明朝", "MS Mincho", serif;',
};

export const dimensions = {
  breakPoint: 600,
};
